import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconKeyboardTabRtlLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.25 17.75a.725.725 0 0 1-.534-.216A.726.726 0 0 1 2.5 17V7c0-.213.072-.39.216-.534a.726.726 0 0 1 .534-.216c.213 0 .391.072.534.216A.725.725 0 0 1 4 7v10c0 .212-.072.39-.216.534a.726.726 0 0 1-.534.216Zm5.806-5 3.308 3.308a.746.746 0 0 1 .227.534.7.7 0 0 1-.227.535.752.752 0 0 1-.53.207.7.7 0 0 1-.515-.207l-4.494-4.494a.83.83 0 0 1-.256-.634.832.832 0 0 1 .256-.632l4.484-4.494a.7.7 0 0 1 .521-.208c.21 0 .385.07.522.207.15.15.224.327.222.531a.71.71 0 0 1-.21.514L9.065 11.25H20.75c.212 0 .39.072.534.216A.726.726 0 0 1 21.5 12a.722.722 0 0 1-.216.534.726.726 0 0 1-.534.216H9.056Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconKeyboardTabRtlLine;
